
import { Component, Vue } from 'vue-property-decorator'
import TicketCggl from '@/views/Ticket/indexCggl.vue'

@Component({
  name: 'AllMyOrderLists',
  components: {
    TicketCggl
  }
})
export default class extends Vue {}
